import styled from 'styled-components';

export const CardOuterWrapper = styled.div(
  props => `
    background: ${props.theme.colors.goWhite.base};
    padding: 6px 8px;
    margin: 0.8rem;
    border-radius: 8px; 
    >img {
        max-width: 100%;

    }
    `,
);

export const TARatingWrapper = styled.p(
  props => `
      display: flex;
      align-items:center;
      `,
);

export const TARatingList = styled.ul(
  props => `
    display: flex;
    `,
);

export const TARatingListItem = styled.li(
  props => `
    display: flex;
    flex-shrink: 0;
    width:${props.circleSize}px;
  height:${props.circleSize}px;
  border-radius:50%;
  overflow:hidden;
  position:relative;
  border: 1px solid #00AA6C;
  margin-right: 1px;
  
  :after {
    position:absolute;
      content: '';
      background: #00AA6C;
      display:block;
      width:${props.circleSize}px;
      height:${props.circleSize}px;
      top:0;
      left:0;
  }
  
  &.half::after {
      left:-${props.circleSize / 2}px;
  }
  
  &.blank:after  {
      background:${props.theme.colors.goWhite.base};
  }
    `,
);

export const TARatingWithCountText = styled.span(
  props => `
    font-size: 12px;
  line-height: 1;
  color: ${props.theme.colors.downriver.medium};
  margin-left: 5px;
    `,
);
